import {
  IEpicDiagramPayload,
  IEpicDiagramResponse,
  IEpicsResponse,
  ITestCasesPayload,
  ITestCasesResponse,
  IUserStoriesForTestCasesResponse,
  IEpicsListResponse,
  IUserStoriesInBacklogBuildQAResponse,
  IUserStoriesInBacklogBuildQAPayload,
  IUserStoriesShapeResponse,
  ITestCasesBuild,
  IDefectsBySprint,
  IDefectsByPriority,
  ITestCasesByStatusResponse,
  ISprintHealthResponse,
  ISprintBurnDownResponse,
  ISprintwiseCapacityResponse,
} from '../../../models/cbo/AIAssistPortletsModel';
import { IStoreAction } from '../../StoreHelper';

export enum AIAssistPortletsActionTypes {
  GET_EPICS_STARTED = 'GET_EPICS_STARTED',
  GET_EPICS_SUCCESS = 'GET_EPICS_SUCCESS',
  GET_EPICS_ERROR = 'GET_EPICS_ERROR',
  GET_EPIC_DIAGRAM_STARTED = 'GET_EPIC_DIAGRAM_STARTED',
  GET_EPIC_DIAGRAM_SUCCESS = 'GET_EPIC_DIAGRAM_SUCCESS',
  GET_EPIC_DIAGRAM_ERROR = 'GET_EPIC_DIAGRAM_ERROR',
  GET_USER_STORIES_FOR_TEST_CASES_STARTED = 'GET_USER_STORIES_FOR_TEST_CASES_STARTED',
  GET_USER_STORIES_FOR_TEST_CASES_SUCCESS = 'GET_USER_STORIES_FOR_TEST_CASES_SUCCESS',
  GET_USER_STORIES_FOR_TEST_CASES_ERROR = 'GET_USER_STORIES_FOR_TEST_CASES_ERROR',
  GET_TEST_CASES_STARTED = 'GET_TEST_CASES_STARTED',
  GET_TEST_CASES_SUCCESS = 'GET_TEST_CASES_SUCCESS',
  GET_TEST_CASES_ERROR = 'GET_TEST_CASES_ERROR',
  GET_EPIC_LIST_STARTED = 'GET_EPIC_LIST_STARTED',
  GET_EPIC_LIST_SUCCESS = 'GET_EPIC_LIST_SUCCESS',
  GET_EPIC_LIST_ERROR = 'GET_EPIC_LIST_ERROR',
  GET_USER_STORIES_BACKLOG_BUILD_QA_STARTED = 'GET_USER_STORIES_BACKLOG_BUILD_QA_STARTED',
  GET_USER_STORIES_BACKLOG_BUILD_QA_SUCCESS = 'GET_USER_STORIES_BACKLOG_BUILD_QA_SUCCESS',
  GET_USER_STORIES_BACKLOG_BUILD_QA_ERROR = 'GET_USER_STORIES_BACKLOG_BUILD_QA_ERROR',
  GET_USER_STORIES_SHAPE_STARTED = 'GET_USER_STORIES_SHAPE_STARTED',
  GET_USER_STORIES_SHAPE_SUCCESS = 'GET_USER_STORIES_SHAPE_SUCCESS',
  GET_USER_STORIES_SHAPE_ERROR = 'GET_USER_STORIES_SHAPE_ERROR',
  GET_TEST_CASES_BUILD_STARTED = 'GET_TEST_CASES_BUILD_STARTED',
  GET_TEST_CASES_BUILD_SUCCESS = 'GET_TEST_CASES_BUILD_SUCCESS',
  GET_TEST_CASES_BUILD_ERROR = 'GET_TEST_CASES_BUILD_ERROR',
  GET_DEFECTS_BY_SPRINT_STARTED = 'GET_DEFECTS_BY_SPRINT_STARTED',
  GET_DEFECTS_BY_SPRINT_SUCCESS = 'GET_DEFECTS_BY_SPRINT_SUCCESS',
  GET_DEFECTS_BY_SPRINT_ERROR = 'GET_DEFECTS_BY_SPRINT_ERROR',
  GET_DEFECTS_BY_PRIORITY_STARTED = 'GET_DEFECTS_BY_PRIORITY_STARTED',
  GET_DEFECTS_BY_PRIORITY_SUCCESS = 'GET_DEFECTS_BY_PRIORITY_SUCCESS',
  GET_DEFECTS_BY_PRIORITY_ERROR = 'GET_DEFECTS_BY_PRIORITY_ERROR',
  GET_TEST_CASES_BY_STATUS_STARTED = 'GET_TEST_CASES_BY_STATUS_STARTED',
  GET_TEST_CASES_BY_STATUS_SUCCESS = 'GET_TEST_CASES_BY_STATUS_SUCCESS',
  GET_TEST_CASES_BY_STATUS_ERROR = 'GET_TEST_CASES_BY_STATUS_ERROR',
  GET_SPRINT_HEALTH_STARTED = 'GET_SPRINT_HEALTH_STARTED',
  GET_SPRINT_HEALTH_SUCCESS = 'GET_SPRINT_HEALTH_SUCCESS',
  GET_SPRINT_HEALTH_ERROR = 'GET_SPRINT_HEALTH_ERROR',
  GET_SPRINT_BURNDOWN_STARTED = 'GET_SPRINT_BURNDOWN_STARTED',
  GET_SPRINT_BURNDOWN_SUCCESS = 'GET_SPRINT_BURNDOWN_SUCCESS',
  GET_SPRINT_BURNDOWN_ERROR = 'GET_SPRINT_BURNDOWN_ERROR',
  GET_SPRINTWISE_CAPACITY_STARTED = 'GET_SPRINTWISE_CAPACITY_STARTED',
  GET_SPRINTWISE_CAPACITY_SUCCESS = 'GET_SPRINTWISE_CAPACITY_SUCCESS',
  GET_SPRINTWISE_CAPACITY_ERROR = 'GET_SPRINTWISE_CAPACITY_ERROR',
}

export type AIAssistPortletsPayload =
  | string
  | Error
  | IEpicsResponse[]
  | IEpicDiagramPayload
  | IEpicDiagramResponse
  | ITestCasesResponse[]
  | ITestCasesPayload
  | IUserStoriesForTestCasesResponse[]
  | IEpicsListResponse[]
  | IUserStoriesInBacklogBuildQAPayload
  | IUserStoriesInBacklogBuildQAResponse[]
  | IUserStoriesShapeResponse[]
  | ITestCasesBuild[]
  | IDefectsBySprint
  | IDefectsByPriority
  | ITestCasesByStatusResponse[]
  | ISprintHealthResponse
  | ISprintBurnDownResponse
  | ISprintwiseCapacityResponse[];

export type AIAssistPortletsAction = IStoreAction<
  AIAssistPortletsActionTypes,
  AIAssistPortletsPayload
>;

export class AIAssistPortletsActions {
  public static getEpicsStarted(data: string | undefined): AIAssistPortletsAction {
    return {
      type: AIAssistPortletsActionTypes.GET_EPICS_STARTED,
      data,
    };
  }

  public static getEpicsSuccess(data: IEpicsResponse[]): AIAssistPortletsAction {
    return {
      type: AIAssistPortletsActionTypes.GET_EPICS_SUCCESS,
      data,
    };
  }

  public static getEpicsError(error: Error): AIAssistPortletsAction {
    return {
      type: AIAssistPortletsActionTypes.GET_EPICS_ERROR,
      data: error,
    };
  }

  public static getEpicDiagramStarted(data: IEpicDiagramPayload): AIAssistPortletsAction {
    return {
      type: AIAssistPortletsActionTypes.GET_EPIC_DIAGRAM_STARTED,
      data,
    };
  }

  public static getEpicDiagramSuccess(data: IEpicDiagramResponse): AIAssistPortletsAction {
    return {
      type: AIAssistPortletsActionTypes.GET_EPIC_DIAGRAM_SUCCESS,
      data,
    };
  }

  public static getEpicDiagramError(error: Error): AIAssistPortletsAction {
    return {
      type: AIAssistPortletsActionTypes.GET_EPIC_DIAGRAM_ERROR,
      data: error,
    };
  }

  public static getUserStoriesForTestCasesStarted(
    data: string | undefined,
  ): AIAssistPortletsAction {
    return {
      type: AIAssistPortletsActionTypes.GET_USER_STORIES_FOR_TEST_CASES_STARTED,
      data,
    };
  }

  public static getUserStoriesForTestCasesSuccess(
    data: IUserStoriesForTestCasesResponse[],
  ): AIAssistPortletsAction {
    return {
      type: AIAssistPortletsActionTypes.GET_USER_STORIES_FOR_TEST_CASES_SUCCESS,
      data,
    };
  }

  public static getUserStoriesForTestCasesError(error: Error): AIAssistPortletsAction {
    return {
      type: AIAssistPortletsActionTypes.GET_USER_STORIES_FOR_TEST_CASES_ERROR,
      data: error,
    };
  }

  public static getTestCasesStarted(data: ITestCasesPayload): AIAssistPortletsAction {
    return {
      type: AIAssistPortletsActionTypes.GET_TEST_CASES_STARTED,
      data,
    };
  }

  public static getTestCasesSuccess(data: ITestCasesResponse[]): AIAssistPortletsAction {
    return {
      type: AIAssistPortletsActionTypes.GET_TEST_CASES_SUCCESS,
      data,
    };
  }

  public static getTestCasesError(error: Error): AIAssistPortletsAction {
    return {
      type: AIAssistPortletsActionTypes.GET_TEST_CASES_ERROR,
      data: error,
    };
  }

  public static getEpicsListStarted(data: string | undefined): AIAssistPortletsAction {
    return {
      type: AIAssistPortletsActionTypes.GET_EPIC_LIST_STARTED,
      data,
    };
  }

  public static getEpicsListSuccess(data: IEpicsListResponse[]): AIAssistPortletsAction {
    return {
      type: AIAssistPortletsActionTypes.GET_EPIC_LIST_SUCCESS,
      data,
    };
  }

  public static getEpicsListError(error: Error): AIAssistPortletsAction {
    return {
      type: AIAssistPortletsActionTypes.GET_EPIC_LIST_ERROR,
      data: error,
    };
  }

  public static getUserStoriesInBacklogBuildQAStarted(
    data: IUserStoriesInBacklogBuildQAPayload,
  ): AIAssistPortletsAction {
    return {
      type: AIAssistPortletsActionTypes.GET_USER_STORIES_BACKLOG_BUILD_QA_STARTED,
      data,
    };
  }

  public static getUserStoriesInBacklogBuildQASuccess(
    data: IUserStoriesInBacklogBuildQAResponse[],
  ): AIAssistPortletsAction {
    return {
      type: AIAssistPortletsActionTypes.GET_USER_STORIES_BACKLOG_BUILD_QA_SUCCESS,
      data,
    };
  }

  public static getUserStoriesInBacklogBuildQAError(error: Error): AIAssistPortletsAction {
    return {
      type: AIAssistPortletsActionTypes.GET_USER_STORIES_BACKLOG_BUILD_QA_ERROR,
      data: error,
    };
  }

  public static getUserStoriesShapeStarted(data: string | undefined): AIAssistPortletsAction {
    return {
      type: AIAssistPortletsActionTypes.GET_USER_STORIES_SHAPE_STARTED,
      data,
    };
  }

  public static getUserStoriesShapeSuccess(
    data: IUserStoriesShapeResponse[],
  ): AIAssistPortletsAction {
    return {
      type: AIAssistPortletsActionTypes.GET_USER_STORIES_SHAPE_SUCCESS,
      data,
    };
  }

  public static getUserStoriesShapeError(error: Error): AIAssistPortletsAction {
    return {
      type: AIAssistPortletsActionTypes.GET_USER_STORIES_SHAPE_ERROR,
      data: error,
    };
  }
  public static getTestCasesBuildStarted(data: string | undefined): AIAssistPortletsAction {
    return {
      type: AIAssistPortletsActionTypes.GET_TEST_CASES_BUILD_STARTED,
      data,
    };
  }

  public static getTestCasesBuildSuccess(data: ITestCasesBuild[]): AIAssistPortletsAction {
    return {
      type: AIAssistPortletsActionTypes.GET_TEST_CASES_BUILD_SUCCESS,
      data,
    };
  }

  public static getTestCasesBuildError(error: Error): AIAssistPortletsAction {
    return {
      type: AIAssistPortletsActionTypes.GET_TEST_CASES_BUILD_ERROR,
      data: error,
    };
  }
  public static getDefectsBySprintStarted(data: string | undefined): AIAssistPortletsAction {
    return {
      type: AIAssistPortletsActionTypes.GET_DEFECTS_BY_SPRINT_STARTED,
      data,
    };
  }

  public static getDefectsBySprintSuccess(data: IDefectsBySprint): AIAssistPortletsAction {
    return {
      type: AIAssistPortletsActionTypes.GET_DEFECTS_BY_SPRINT_SUCCESS,
      data,
    };
  }

  public static getDefectsBySprintError(error: Error): AIAssistPortletsAction {
    return {
      type: AIAssistPortletsActionTypes.GET_DEFECTS_BY_SPRINT_ERROR,
      data: error,
    };
  }
  public static getDefectsByPriorityStarted(data: string | undefined): AIAssistPortletsAction {
    return {
      type: AIAssistPortletsActionTypes.GET_DEFECTS_BY_PRIORITY_STARTED,
      data,
    };
  }

  public static getDefectsByPrioritySuccess(data: IDefectsByPriority): AIAssistPortletsAction {
    return {
      type: AIAssistPortletsActionTypes.GET_DEFECTS_BY_PRIORITY_SUCCESS,
      data,
    };
  }

  public static getDefectsByPriorityError(error: Error): AIAssistPortletsAction {
    return {
      type: AIAssistPortletsActionTypes.GET_DEFECTS_BY_PRIORITY_ERROR,
      data: error,
    };
  }

  public static getTestCasesByStatusStarted(data: string | undefined): AIAssistPortletsAction {
    return {
      type: AIAssistPortletsActionTypes.GET_TEST_CASES_BY_STATUS_STARTED,
      data,
    };
  }
  public static getTestCasesByStatusSuccess(
    data: ITestCasesByStatusResponse[],
  ): AIAssistPortletsAction {
    return {
      type: AIAssistPortletsActionTypes.GET_TEST_CASES_BY_STATUS_SUCCESS,
      data,
    };
  }
  public static getTestCasesByStatusError(error: Error): AIAssistPortletsAction {
    return {
      type: AIAssistPortletsActionTypes.GET_TEST_CASES_BY_STATUS_ERROR,
      data: error,
    };
  }

  public static getSprintHealthStarted(data: string | undefined): AIAssistPortletsAction {
    return {
      type: AIAssistPortletsActionTypes.GET_SPRINT_HEALTH_STARTED,
      data,
    };
  }
  public static getSprintHealthSuccess(data: ISprintHealthResponse): AIAssistPortletsAction {
    return {
      type: AIAssistPortletsActionTypes.GET_SPRINT_HEALTH_SUCCESS,
      data,
    };
  }
  public static getSprintHealthError(error: Error): AIAssistPortletsAction {
    return {
      type: AIAssistPortletsActionTypes.GET_SPRINT_HEALTH_ERROR,
      data: error,
    };
  }

  public static getSprintBurnDownStarted(data: string | undefined): AIAssistPortletsAction {
    return {
      type: AIAssistPortletsActionTypes.GET_SPRINT_BURNDOWN_STARTED,
      data,
    };
  }
  public static getSprintBurnDownSuccess(data: ISprintBurnDownResponse): AIAssistPortletsAction {
    return {
      type: AIAssistPortletsActionTypes.GET_SPRINT_BURNDOWN_SUCCESS,
      data,
    };
  }
  public static getSprintBurnDownError(error: Error): AIAssistPortletsAction {
    return {
      type: AIAssistPortletsActionTypes.GET_SPRINT_BURNDOWN_ERROR,
      data: error,
    };
  }

  public static getSprintwiseCapacityStarted(data: string | undefined): AIAssistPortletsAction {
    return {
      type: AIAssistPortletsActionTypes.GET_SPRINTWISE_CAPACITY_STARTED,
      data,
    };
  }

  public static getSprintwiseCapacitySuccess(
    data: ISprintwiseCapacityResponse[],
  ): AIAssistPortletsAction {
    return {
      type: AIAssistPortletsActionTypes.GET_SPRINTWISE_CAPACITY_SUCCESS,
      data,
    };
  }

  public static getSprintwiseCapacityError(error: Error): AIAssistPortletsAction {
    return {
      type: AIAssistPortletsActionTypes.GET_SPRINTWISE_CAPACITY_ERROR,
      data: error,
    };
  }
}
